module.exports = __webpack_public_path__ + "static/img/1.22035a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./plugins/verifyCode/images/1.jpg
// module id = F7lk
// module chunks = 1